import { RidangoReduxAction } from '@ridango/core';

import { tassign } from 'tassign';

import { BankcardTicket } from '../model/bankcard-ticket.model';
import { BankcardTransaction } from '../model/bankcard-transaction.model';
import { BankcardTicketsActions } from './bankcard-tickets.actions';

export interface BankcardTicketsState {
    transaction: BankcardTransaction;
    error: any;
    ticketsError: any;
    tickets: BankcardTicket[];
    ticketsLoading: boolean;
    hslTickets: BankcardTicket[];
    hslTicketsLoading: boolean;
    loading: boolean;
    feedbackSuccess: boolean;
}
export const BANKCARD_TICKETS_INITIAL_STATE: BankcardTicketsState = {
    transaction: null,
    error: null,
    ticketsError: null,
    tickets: null,
    ticketsLoading: false,
    hslTickets: null,
    hslTicketsLoading: false,
    loading: false,
    feedbackSuccess: false,
};

export const BANKCARD_TICKETS_STATE_KEY = 'bankcardTickets';

export function bankcardTicketsReducer(
    lastState: BankcardTicketsState = BANKCARD_TICKETS_INITIAL_STATE,
    action: RidangoReduxAction
): BankcardTicketsState {
    switch (action.type) {
        case BankcardTicketsActions.FETCH_TRANSACTION:
            return tassign(lastState, {});
        case BankcardTicketsActions.SET_TRANSACTION:
            return tassign(lastState, { transaction: action.payload });
        case BankcardTicketsActions.SET_FAILED:
            return tassign(lastState, { error: action.payload });
        case BankcardTicketsActions.FETCH_TICKETS:
            return tassign(lastState, { ticketsLoading: true });
        case BankcardTicketsActions.SET_TICKETS:
            return tassign(lastState, { tickets: action.payload, ticketsLoading: false });
        case BankcardTicketsActions.SET_TICKETS_FAILED:
            return tassign(lastState, { ticketsError: action.payload, ticketsLoading: false });
        case BankcardTicketsActions.FETCH_HSL_TICKETS:
            return tassign(lastState, { hslTicketsLoading: true });
        case BankcardTicketsActions.SET_HSL_TICKETS:
            return tassign(lastState, { hslTickets: action.payload, hslTicketsLoading: false });
        case BankcardTicketsActions.SET_HSL_TICKETS_FAILED:
            return tassign(lastState, { ticketsError: action.payload, hslTicketsLoading: false });
        case BankcardTicketsActions.SEND_FEEDBACK_SUCCESS:
            return tassign(lastState, { feedbackSuccess: true });
        case BankcardTicketsActions.CLEAN_STATE:
            return tassign(lastState, BANKCARD_TICKETS_INITIAL_STATE);
    }

    return lastState;
}

export interface BankcardTicketsPartialStoreState {
    [BANKCARD_TICKETS_STATE_KEY]: BankcardTicketsState;
}
